import { types } from "../types/types";

export const openSidebar = (show) => ({
  type: types.openSideBar,
  payload: show,
});

export const importOpenSidebar = (show) => {
  return async (dispatch) => {
    try {
      dispatch(openSidebar(show));
    } catch (error) {
      console.error(error);
    }
  };
};
